import Constant from "./Constant";

const TranslationConstant = {
    ON_DEMAND_TRANSLATION_STATUS: {
        IDLE: 'idle',
        LOADING: 'loading',
        TRANSLATED: 'translated',
        ERROR: 'error'
    },
    ON_DEMAND_TRANSLATION_VIEW: {
        ORIGINAL: 'original',
        TRANSLATION: 'translation'
    },
    // Source of an on-demand translation request. The BE branches on this to fetch
    // the content itself (FE only sends ids, not content). Keep in sync with BE
    // Translation.ON_DEMAND_SOURCE_TYPE.
    ON_DEMAND_SOURCE_TYPE: {
        TICKET: 'TICKET',
        CHAT: 'CHAT'
    },
    // Reserved key in the on-demand result map holding the translated outline/title.
    // The FE sends the outline text and reads its translation back under this key.
    // Keep in sync with BE OnDemandTranslateService.OUTLINE_KEY.
    ON_DEMAND_OUTLINE_KEY: 'outline',

    // Default main language (主言語) when a user has not chosen one yet.
    DEFAULT_MAIN_LANGUAGE: 'ja',

    IGNORE_ON_DEMAND_FIELDS: [
        Constant.SYS_FIELD.ATTACHMENTS,
        Constant.TICKET_DATA_ID.ATTACHMENT,
        Constant.SYSTEM_FIELD.TICKET_TYPE,
        Constant.SYSTEM_FIELD.PAGE_NO,
    ],
    
    // Auto-detect source-language option (empty code) for the file auto-translate dropdown (BR-3).
    AUTO_DETECT_LANG_CODE: '',

    // Max target languages selectable per config (BR-4 / TRANSLATION_MAX_TARGET_LANGS).
    MAX_TARGET_TRANSLATE_LANGS: 10,

    // Debounce window (ms) to batch a burst of new chat messages into ONE auto-translate request.
    AUTO_TRANSLATE_DEBOUNCE_MS: 500,

    // Translatable file extensions (mirror of Translation.TRANSLATION_SUPPORTED_EXTENSIONS).
    TRANSLATION_SUPPORTED_EXTENSIONS: ['pdf', 'docx', 'pptx', 'xlsx'],
    // Supported languages. Same code set as BE Translation.TRANSLATION_LANG_DISPLAY_JP (Google Cloud
    // Translation supported list) minus the BE-only alias keys he / tl - FE cannot import the Lambda
    // layer, so the map is duplicated here and test/src/common/constant/TranslationLangSync.test.js
    // fails when the two drift apart. Codes Google does not list stay commented out on the BE side.
    TRANSLATION_LANG_DISPLAY_JP: {
        af: 'Afrikaans',
        am: 'አማርኛ',
        ar: 'العربية',
        az: 'Azərbaycan dili',
        be: 'Беларуская',
        bg: 'Български',
        bn: 'বাংলা',
        bs: 'Bosanski',
        ca: 'Català',
        ceb: 'Cebuano',
        co: 'Corsu',
        cs: 'Čeština',
        cy: 'Cymraeg',
        da: 'Dansk',
        de: 'Deutsch',
        el: 'Ελληνικά',
        en: 'English',
        es: 'Español',
        et: 'Eesti',
        eu: 'Euskara',
        fa: 'فارسی',
        fi: 'Suomi',
        fil: 'Filipino',
        fr: 'Français',
        fy: 'Frysk',
        ga: 'Gaeilge',
        gd: 'Gàidhlig',
        gl: 'Galego',
        gn: 'Avañeʼẽ',
        gu: 'ગુજરાતી',
        ha: 'Hausa',
        haw: 'ʻŌlelo Hawaiʻi',
        he: 'עברית',
        hi: 'हिन्दी',
        hmn: 'Hmoob',
        hr: 'Hrvatski',
        ht: 'Kreyòl ayisyen',
        hu: 'Magyar',
        hy: 'Հայերեն',
        id: 'Bahasa Indonesia',
        ig: 'Igbo',
        is: 'Íslenska',
        it: 'Italiano',
        ja: '日本語',
        jv: 'Basa Jawa',
        ka: 'ქართული',
        kk: 'Қазақ тілі',
        km: 'ខ្មែរ',
        kn: 'ಕನ್ನಡ',
        ko: '한국어',
        ku: 'Kurdî',
        ky: 'Кыргызча',
        lb: 'Lëtzebuergesch',
        ln: 'Lingála',
        lo: 'ລາວ',
        lt: 'Lietuvių',
        lv: 'Latviešu',
        mg: 'Malagasy',
        mi: 'Māori',
        mk: 'Македонски',
        ml: 'മലയാളം',
        mn: 'Монгол',
        mr: 'मराठी',
        ms: 'Bahasa Melayu',
        mt: 'Malti',
        my: 'မြန်မာဘာသာ',
        ne: 'नेपाली',
        nl: 'Nederlands',
        no: 'Norsk',
        ny: 'Chichewa',
        or: 'ଓଡ଼ିଆ',
        pa: 'ਪੰਜਾਬੀ',
        pl: 'Polski',
        ps: 'پښتو',
        pt: 'Português',
        ro: 'Română',
        ru: 'Русский',
        rw: 'Kinyarwanda',
        sd: 'سنڌي',
        si: 'සිංහල',
        sk: 'Slovenčina',
        sl: 'Slovenščina',
        sm: 'Gagana Samoa',
        sn: 'ChiShona',
        so: 'Soomaali',
        sq: 'Shqip',
        sr: 'Српски',
        st: 'Sesotho',
        su: 'Basa Sunda',
        sv: 'Svenska',
        sw: 'Kiswahili',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        tg: 'Тоҷикӣ',
        th: 'ไทย',
        tk: 'Türkmençe',
        tr: 'Türkçe',
        tt: 'Татарча',
        ug: 'ئۇيغۇرچە',
        uk: 'Українська',
        ur: 'اردو',
        uz: 'Oʻzbekcha',
        vi: 'Tiếng Việt',
        xh: 'isiXhosa',
        yi: 'ייִדיש',
        yo: 'Yorùbá',
        zh: '中文（简体）',
        'zh-TW': '中文（繁體）',
        zu: 'isiZulu'
    }
};

export default TranslationConstant;
